/* @flow */

export default class ExtendsLeadLifetimeRequest {
  companyId: number;
  leadId: number;
  lifetimeExtensionReason: string;
}
